import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2t69ysb2gm: FaireBrandEntity = {
  token: "b_2t69ysb2gm",
  type: "brand",
  name: "Woven",
  avatarUrl:
    "https://cdn.faire.com/fastly/cd62d2d2074d238e3ea0c7e8d45a097aaff00f8a061aa1a6280904606e3d01b9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/73a2511304182647c3c82fd79d1ccd19d01de0ef2135dfe2c6d80ebfbb31ad9c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cd62d2d2074d238e3ea0c7e8d45a097aaff00f8a061aa1a6280904606e3d01b9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/73a2511304182647c3c82fd79d1ccd19d01de0ef2135dfe2c6d80ebfbb31ad9c.jpeg",
  location: "Mansons landing , BC, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 2,
  isTopShop: true,
  isInsider: false,
  description:
    "Welcome to Woven- a creative workshop where we are  hand-dipping and hand-pouring beeswax candles. Located on beautiful Cortes Island, BC. Here at Woven, we craft each pair of candles with care, while enjoying the traditional art of candle making. When not in the studio, you will find us in the apiary hanging out with our honey bees. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:20.166Z",
    importedBy: "entity-db-cli",
  },
};
